<template>
	<AppLazyLoaderComponentFromMonolith
		:params="params"
		:container="Monolith.LAZY_CONTAINER.GANTT_CHART"
	/>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Monolith } from '@/constants/monolith';
import { AppLazyLoaderComponentFromMonolith } from '@/features/App';
import { type Project } from '@/generated/graphql';

const props = defineProps<{
	projectId: Project['id'];
	retainerPeriodId: number | undefined;
}>();

const params = computed(() => ({
	project_id: String(props.projectId),
	retainerPeriodId: String(props.retainerPeriodId),
}));
</script>
